<!--Copyright (c) PikPok. All rights reserved-->
<template>
  <v-container :fluid="true" class="ma-0 pa-0 home-container" v-if="loading">
    <!-- Forms -->
    <v-row style="margin-top: -40px">
      <v-col cols="1" sm="1" md="1" lg="2"></v-col>
      <v-col cols="10" sm="10" md="10" lg="8">
        <v-row align="center">
          <!-- Technical Issue -->
          <v-col cols="12" sm="6" md="6" lg="4" align="center">
            <v-hover v-slot="{ isHovering, props }">
              <div class="link-card" v-bind="props" :class="`elevation-${isHovering ? 24 : 6}`">
                <router-link to="/technical_issue">
                  <div class="card-title">
                    <span>
                       <v-btn color="yellow-darken-3" class="button-size" icon="mdi-cog">
                          <v-icon color="white" class="icon-size"></v-icon>
                       </v-btn>
                    </span>
                  </div>
                  <h3 class="title-heading text-grey-darken-2">
                    {{ localeKeys.strings.BUG_TECHNICAL_ISSUE }}
                  </h3>
                </router-link>
              </div>
            </v-hover>
          </v-col>
          <!-- Lost Items & Account Recovery -->
          <v-col cols="12" sm="6" md="6" lg="4" align="center">
            <v-hover v-slot="{ isHovering, props }">
              <div class="link-card" v-bind="props" :class="`elevation-${isHovering ? 24 : 6}`">
                <router-link to="/account_and_data_help">
                  <div class="card-title">
                    <span>
                       <v-btn color="yellow-darken-3" class="button-size" icon="mdi-account">
                          <v-icon color="white" class="icon-size"></v-icon>
                       </v-btn>
                    </span>
                  </div>
                  <h3 class="title-heading text-grey-darken-2">
                    {{ localeKeys.strings.BUG_ACCOUNT_AND_DATA }}
                  </h3>
                </router-link>
              </div>
            </v-hover>
          </v-col>
          <!-- Purchases & refunds Support -->
          <v-col cols="12" sm="6" md="6" lg="4" align="center">
            <v-hover v-slot="{ isHovering, props }">
              <div class="link-card" v-bind="props" :class="`elevation-${isHovering ? 24 : 6}`">
                <router-link to="/billing_and_subscription">
                  <div class="card-title">
                    <span>
                       <v-btn color="yellow-darken-3" class="button-size" icon="mdi-currency-usd">
                          <v-icon color="white" class="icon-size"></v-icon>
                       </v-btn>
                    </span>
                  </div>
                  <h3 class="title-heading text-grey-darken-2">
                    {{ localeKeys.strings.BUG_BILLING_AND_SUBSCRIPTION }}
                  </h3>
                </router-link>
              </div>
            </v-hover>
          </v-col>
          <!-- Game Suggestions & Community Feedback -->
          <v-col cols="12" sm="6" md="6" lg="4" align="center">
            <v-hover v-slot="{ isHovering, props }">
              <div class="link-card" v-bind="props" :class="`elevation-${isHovering ? 24 : 6}`">
                <router-link to="/game_suggestion_and_feedback">
                  <div class="card-title">
                    <span>
                       <v-btn color="yellow-darken-3" class="button-size" icon="mdi-controller">
                          <v-icon color="white" class="icon-size"></v-icon>
                       </v-btn>
                    </span>
                  </div>
                  <h3 class="title-heading text-grey-darken-2">
                    {{ localeKeys.strings.BUG_GAME_SUGGESTIONS }}
                  </h3>
                </router-link>
              </div>
            </v-hover>
          </v-col>
          <!-- FQA -->
          <v-col cols="12" sm="6" md="6" lg="4" align="center">
            <v-hover v-slot="{ isHovering, props }">
              <div class="link-card" v-bind="props" :class="`elevation-${isHovering ? 24 : 6}`">
                <a href="http://faq.pikpok.com" target="_blank">
                  <div class="card-title">
                    <span>
                       <v-btn color="yellow-darken-3" class="button-size" icon="mdi-chat-question">
                          <v-icon color="white" class="icon-size"></v-icon>
                       </v-btn>
                    </span>
                  </div>
                  <h3 class="title-heading text-grey-darken-2">
                    {{ localeKeys.strings.BUG_FREQUENTLY_ASKED_ABOUT }}
                  </h3>
                </a>
              </div>
            </v-hover>
          </v-col>
          <!-- Privacy Policy -->
          <v-col cols="12" sm="6" md="6" lg="4" align="center">
            <v-hover v-slot="{ isHovering, props }">
              <div class="link-card" v-bind="props" :class="`elevation-${isHovering ? 24 : 6}`">
                <router-link to="/privacy">
                  <div class="card-title">
                    <span>
                       <v-btn color="yellow-darken-3" class="button-size" icon="mdi-shield-lock">
                          <v-icon color="white" class="icon-size"></v-icon>
                       </v-btn>
                    </span>
                  </div>
                  <h3 class="title-heading text-grey-darken-2">{{ localeKeys.strings.SUPPORT_PRIVACY_POLICY }}</h3>
                </router-link>
              </div>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1" sm="1" md="1" lg="2">
      </v-col>
    </v-row>

    <!-- Live Issues -->
    <v-row class="mb-10 mt-10">
      <v-col cols="1" sm="1" md="1" lg="2"></v-col>
      <v-col cols="10" sm="10" md="10" lg="8" align="center">
        <v-row align="center">
          <v-col cols="12">
            <div class="live-issue-container">
              <h2 class="text-grey-darken-2">{{ localeKeys.strings.LIVE_ISSUE_HEADER }}</h2>
              <p class="pt-5 pb-5">
                {{ localeKeys.strings.LIVE_ISSUE_SUB_HEADING }}
              </p>
              <v-btn
                  color="yellow-darken-3"
                  size="x-large" rounded="lg"
                  href="https://status.pikpok.com/"
                  target="_blank">
                <span class="pl-15 pr-15 text-white" style="font-family: 'Open Sans' sans-serif !important;">{{ localeKeys.strings.CLICK_HERE_BUTTON }}</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1" sm="1" md="1" lg="2"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "HomeComponent",
  components: {},
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...
        mapState({
          localeKeys: state => state.supportStore.localeKeys,
        }),
  },
  mounted() {
    this.getLocaleKeys({
      params: {
        appname: this.$route.query.appname ? this.$route.query.appname : "",
        os: this.$route.query.os ? this.$route.query.os : ""
      }
    }).then(() => {
      this.loading = true
    })
  },
  methods: {
    ...mapActions([
      'getLocaleKeys'
    ])
  }
}
</script>

<style scoped lang="scss">
.icon-size {
  font-size: 40px;
}

.button-size {
  height: 55px;
  width: 55px;
}

.live-issue-container {
  padding: 25px;
  border: 2px solid #999;
}

.live-issue-container-inner {
  padding: 30px 400px 30px 400px;
  text-align: center;
  position: relative;
}

.link-card {
  border: 2px solid #999;
  padding: 5px;
  text-align: center;
  position: relative;
  background-color: white;
  min-height: 140px;
  margin: 5px;
  border-radius: 15px;
}

.card-title {
  padding: 0 5px;
  margin: -35px 0 0 0;
}

.card-title span {
  background: white;
}

.title-heading {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media only screen and (max-width: 1500px) and (min-width: 650px) {
  .icon-size {
    font-size: 35px;
  }
  .card-title {
    margin: -30px 0 0 0;
  }
  .button-size {
    height: 45px;
    width: 45px;
  }
  h3 {
    font-size: 0.9rem !important;
  }
}

@media only screen and (max-width: 650px) {
  .icon-size {
    font-size: 35px;
  }
  .card-title {
    margin: -35px 0 0 0;
  }
  .button-size {
    height: 50px;
    width: 50px;
  }
  h3 {
    font-size: 0.9rem !important;
  }
}
</style>